import { css } from '@emotion/react';
import React, { useState } from 'react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { PhotoIcon } from '@kaiizen/kai-shiki/react';

/** A product other than the template's: framed in the override color, like an overridden field. */
const FOCUSED_LINE_ITEM_PRODUCT_THUMB_OVERRIDDEN = css`
  label: FOCUSED_LINE_ITEM_PRODUCT_THUMB_OVERRIDDEN;
  border: 1.5px solid ${COLORS.error};
`;

/** The product image, or a placeholder mark while it has none, in a white 36px frame. */
const FOCUSED_LINE_ITEM_PRODUCT_THUMB = css`
  label: FOCUSED_LINE_ITEM_PRODUCT_THUMB;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  overflow: hidden;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.stroke};
  color: ${COLORS.midtone};

  & > svg {
    width: 16px;
    height: 16px;
  }

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

/** Layered onto FOCUSED_LINE_ITEM_PRODUCT_THUMB where a product is named in a line of text: 20px, sitting on the text. */
const FOCUSED_LINE_ITEM_PRODUCT_THUMB_COMPACT = css`
  label: FOCUSED_LINE_ITEM_PRODUCT_THUMB_COMPACT;
  width: 20px;
  height: 20px;

  & > svg {
    width: 12px;
    height: 12px;
  }
`;

/** A product's photo in its square, or the no-photo icon: without a product, without a photo link, or when the photo won't load. */
export const FocusedLineItemProductPhoto = ({ image, overridden, compact }: {
  image: string | undefined;
  /** Framed in the override color: the line's product is other than its template's. */
  overridden?: boolean;
  /** The 20px square for a product named in a line of text, as a change-order strip names one. */
  compact?: boolean;
}) => {
  const [photoFailed, setPhotoFailed] = useState(false);
  return (
    <div
      css={[FOCUSED_LINE_ITEM_PRODUCT_THUMB, overridden && FOCUSED_LINE_ITEM_PRODUCT_THUMB_OVERRIDDEN, compact && FOCUSED_LINE_ITEM_PRODUCT_THUMB_COMPACT]}
      data-testid='focused-line-item-product-thumb'
    >
      {image && !photoFailed ? <img src={image} alt='' onError={() => setPhotoFailed(true)} /> : <PhotoIcon />}
    </div>
  );
};
